<template>
  <div class="lender-card-layout">
    <v-card>
      <div class="img-wrapper">
        <slot name="logo" />
      </div>

      <div class="score-wrapper">
        <slot name="score" />
      </div>

      <div class="button-group-wrapper">
        <slot name="contactButton" />
        <slot name="infoButton" />
      </div>

      <template v-if="$vuetify.breakpoint.mdAndUp">
        <div class="title-wrapper">
          <slot name="title" />
        </div>

        <div class="loan-details-title">
          Lender Details
        </div>

        <div class="loan-details-divider">
          <hr />
        </div>

        <div class="loan-details-wrapper">
         <slot name="loanDetails" />
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LenderCardLayout',
}
</script>

<style lang="scss" scoped>
::v-deep {
  .img-wrapper {
    @include gridPos(1, 2, 1, 2);

    @include md {
      @include gridPos(1, 3, 1, 2);
    }

    @include lg {
      @include gridPos(1, 4, 1, 2);
    }
  }

  .score-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    @include gridPos(2, 3, 1, 2);

    span {
      color: black;
      font-family: "Avenir Book", sans-serif;
      font-size: 14px;
    }

    @include sm {
      @include gridPos(1, 2, 2, 3);
    }

    @include md {
      flex-direction: row;
      align-items: flex-start;

      @include gridPos(2, 3, 2, 3);

      span { margin-top: 4px; }
    }

    @include lg {
      @include gridPos(2, 3, 2, 4);

    }
  }

  .title-wrapper  {
    @include gridPos(1, 2, 2, 3);

    @include lg {
      @include gridPos(1, 2, 2, 4);
    }
  }

  .loan-details-title {
    align-self: center;

    color: $textGrey;
    font-family: "Sansation Regular", sans-serif;
    font-size: 12px;
    text-align: right;

    @include gridPos(3, 4, 1, 2);

    @include lg {
      @include gridPos(3, 4, 2, 3);
    }
  }

  .loan-details-divider {
    align-self: center;

    @include gridPos(3, 4, 2, 3);

    hr {
      flex-grow: 1;

      height: 3px;
      width: 100%;
      margin: 0;

      background-color: #C2F0F5;
      border: none;
    }

    @include lg {
      @include gridPos(3, 4, 3, 4);
    }
  }

  .loan-details-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    text-align: center;

    div {
      padding: 0 7px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    h3 {
      color: $accentBlue;
      font-size: 16px;
      line-height: 16px;
    }

    p {
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 12px;
      line-height: 12px;
    }

    @include gridPos(4, 5, 2, 3);

    @include lg {
      @include gridPos(4, 5, 2, 4);

      h3 {
        font-size: 22px;
        line-height: 26px;
      }
    }

    @include xl {
      h3 {
        font-size: 24px;
        line-height: 28px;
      }
    }
  }

  .button-group-wrapper {
    display: flex;
    flex-direction: column;

    @include gridPos(3, 4, 1, 2);

    .default-btn {
      width: 190px;
      margin-top: 10px;
      margin-bottom: 10px;

      font-size: 16px;
      line-height: 18px;
    }

    @include sm {
      flex-direction: row;
      justify-content: center;

      @include gridPos(2, 3, 1, 3);
    }

    @include md {
      @include gridPos(5, 6, 1, 3);
    }

    @include lg {
      flex-direction: column;
      justify-content: flex-start;

      @include gridPos(1, 5, 4, 5);
    }
  }
}

.lender-card-layout {
  width: 100%;
  margin-top: 30px;
  &:last-of-type { margin-bottom: 30px; }

  .button-group {
    margin-top: 28px;
    margin-bottom: 20px;

    display: flex;
    justify-content: flex-start;
  }
}

.v-card {
  flex-shrink: 0;
  display: grid;
  justify-content: center;

  height: auto;
  width: 100%;
  padding: 20px 10px;

  background-color: white;
  box-shadow: 0px 7px 20px #00000029;

  grid-template-columns: auto;
  grid-auto-rows: auto auto auto;

  grid-column-gap: 10px;
  grid-row-gap: 5px;

  @include sm {
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
  }

  @include md {
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto auto auto auto;
  }

  @include lg {
    grid-template-columns: auto auto 1fr auto;
    grid-template-rows: auto auto auto auto;
    padding: 30px 20px;
  }
}
</style>
